<style src="./NewCmed.scss" lang="scss" scoped></style>
<template>
  <section class="new-cmed">
    <transition name="transition-tab-item">
      <form-file-input
        @close="closePanel" />
    </transition>

  </section>
</template>

<script>
import { PanelTab, PanelTabItem } from '@/components/primitives'
import FormDataInput from './form-data-input/FormDataInput'
import FormFileInput from './form-file-input/FormFileInput'

export default {
  name: 'NewCmed',
  components: {
    PanelTab,
    PanelTabItem,
    FormDataInput,
    FormFileInput
  },
  data () {
    return {
      panelTab: {
        panelTabChoose: 'INSERIR'
      }
    }
  },
  methods: {
    closePanel () {
      this.$parent.$emit('close', false)
    },
    changePanelTab (pPanelItemId) {
      this.panelTab.panelTabChoose = pPanelItemId
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/cmed/components/new-cmed/NewCmed.vue